import React from 'react';
export function PrivacyPolicy() {
  return <div className="space-y-6" data-id="element-92">
      <section data-id="element-93">
        <h3 className="text-xl font-bold text-white mb-3" data-id="element-94">
          1. Recopilación de Datos
        </h3>
        <p className="leading-relaxed" data-id="element-95">
          Para procesar su compra y entregar el "Protocolo Adiós Insomnio 3AM",
          recopilamos información básica necesaria como su nombre, dirección de
          correo electrónico y detalles de pago. Esta información es procesada a
          través de pasarelas de pago seguras y encriptadas. No almacenamos los
          datos completos de su tarjeta de crédito en nuestros servidores.
        </p>
      </section>

      <section data-id="element-96">
        <h3 className="text-xl font-bold text-white mb-3" data-id="element-97">
          2. Uso de la Información
        </h3>
        <p className="leading-relaxed" data-id="element-98">
          La información recopilada se utiliza exclusivamente para: entregar el
          producto digital adquirido, enviar actualizaciones relevantes sobre el
          protocolo, proporcionar soporte al cliente si lo requiere, y procesar
          reembolsos en caso de que aplique la garantía. No vendemos, alquilamos
          ni compartimos su información personal con terceros para fines de
          marketing.
        </p>
      </section>

      <section data-id="element-99">
        <h3 className="text-xl font-bold text-white mb-3" data-id="element-100">
          3. Protección de Datos
        </h3>
        <p className="leading-relaxed" data-id="element-101">
          Implementamos medidas de seguridad estándar de la industria para
          proteger su información personal contra acceso no autorizado,
          alteración, divulgación o destrucción. Nuestro sitio web utiliza
          encriptación SSL para asegurar que todas las transferencias de datos
          entre su navegador y nuestros servidores sean seguras.
        </p>
      </section>

      <section data-id="element-102">
        <h3 className="text-xl font-bold text-white mb-3" data-id="element-103">
          4. Derechos del Usuario
        </h3>
        <p className="leading-relaxed" data-id="element-104">
          Usted tiene el derecho de acceder, corregir o solicitar la eliminación
          de su información personal en cualquier momento. Si desea ejercer
          estos derechos o tiene preguntas sobre cómo manejamos sus datos, puede
          contactarnos a través de los canales de soporte proporcionados tras su
          compra.
        </p>
      </section>

      <section data-id="element-105">
        <h3 className="text-xl font-bold text-white mb-3" data-id="element-106">5. Uso de Cookies</h3>
        <p className="leading-relaxed" data-id="element-107">
          Utilizamos cookies esenciales para el funcionamiento básico del sitio
          web y el procesamiento del carrito de compras. También podemos usar
          cookies analíticas anónimas para entender cómo los visitantes
          interactúan con nuestra página, lo que nos ayuda a mejorar la
          experiencia del usuario. Puede configurar su navegador para rechazar
          todas las cookies, aunque esto podría afectar la funcionalidad del
          proceso de compra.
        </p>
      </section>

      <p className="text-sm text-slate-400 mt-8 pt-4 border-t border-slate-700" data-id="element-108">
        Última actualización:{' '}
        {new Date().toLocaleDateString('es-ES', {
        month: 'long',
        year: 'numeric'
      })}
      </p>
    </div>;
}